export const GROUP_SUFFIX = '@g.us';
export const USER_SUFFIX = '@s.whatsapp.net';
export const LID_SUFFIX = '@lid';

export const isGroupIdentifier = identifier => {
  return (
    typeof identifier === 'string' && identifier.trim().endsWith(GROUP_SUFFIX)
  );
};

export const normalizePhoneValue = value => {
  const digits = String(value || '').replace(/[^\d]/g, '');
  return digits || '';
};

export const extractPhoneFromJid = jid => {
  const value = String(jid || '').trim();

  if (!value || value.endsWith(LID_SUFFIX)) {
    return '';
  }

  if (value.endsWith(USER_SUFFIX)) {
    return normalizePhoneValue(value.split('@')[0]);
  }

  if (/^\+?\d{7,15}$/.test(value)) {
    return normalizePhoneValue(value);
  }

  return '';
};

export const getParticipantPhone = participant => {
  return (
    normalizePhoneValue(
      participant?.PhoneNumber || participant?.phone || participant?.Phone
    ) ||
    extractPhoneFromJid(participant?.JID || participant?.jid || participant?.id)
  );
};

export const getParticipantName = participant => {
  return (
    participant?.DisplayName ||
    participant?.displayName ||
    participant?.FullName ||
    participant?.PushName ||
    participant?.Name ||
    participant?.name ||
    getParticipantPhone(participant) ||
    participant?.JID ||
    participant?.jid ||
    ''
  );
};

export const normalizeGroupParticipant = participant => {
  const phone = getParticipantPhone(participant);
  const identifier =
    participant?.JID || participant?.jid || participant?.id || '';

  return {
    raw: participant,
    id: identifier || `${getParticipantName(participant)}-${phone}`,
    identifier,
    displayName: getParticipantName(participant),
    phone,
    mentionToken: phone ? `@${phone}` : '',
    mentionable: Boolean(phone),
    isAdmin: Boolean(participant?.IsAdmin || participant?.isAdmin),
    isSuperAdmin: Boolean(
      participant?.IsSuperAdmin || participant?.isSuperAdmin
    ),
  };
};

export const getParticipantRole = participant => {
  if (participant.isSuperAdmin) {
    return 'super_admin';
  }

  if (participant.isAdmin) {
    return 'admin';
  }

  return 'member';
};

export const buildGroupExportRows = participants => {
  return participants.map(participant => ({
    name: participant.displayName,
    phone: participant.phone,
    identifier: participant.identifier,
    admin: getParticipantRole(participant),
  }));
};
